/**
 * Created by sumudu on 5/18/16.
 */
'use strict';

(function () {
    angular
        .module('crewing')
        .component('crewScheduleComponent', {
            templateUrl: 'crewing/components/crew-schedule-component.tpl.html',
            bindings: {
                fromData: '<',
                toDate: '<',
                dateFormat: '@',
                currentTime: '<',
                timeZoneText: '@',
                crewScheduleData: '<',
                openPairingData: '<',
                viewMode: '<', //M - MONTH / W - WEEK,
                onBlockDelete: '&',
                onSwapDuty: '&',
                onPasteBlock: '&',
                onEditBlock: '&',
                onAssignPairing: '&',
                onAssignOpenPairing: '&',
                onAssignTraining: '&',
                onAssignEvent: '&',
                onReloadOpenPairingsClick: '&',
                onDirectAction: '&',
                onSendSms: '&',
                onSendAlert: '&',
                onAddMemo: '&',
                onShowRegulations: '&',
                onReplacePairing: '&',
                onShowHistory: '&',
                onShowAllCrewsInSchedule: '&',
                onShowCrewSchedule: '&',
                onEmailCrewSchedule: '&',
                onEditPairing: '&',
                onShowPaxMsgDet:'&',
                onAssignDirectOfcEventInRosters: '&',
                startIndex: '=',
                isFilterModeActive: '=',
                searchParam : '=',
                blockParams: '='
            },
            controller: function ($q, $scope, $rootScope, $timeout, $interval, $filter, $window, SlideInPanelService, ContextMenuService, EventManagerService, hotkeys,
                                  PopupManager, crewingConstants, MessageService, CrewingSelectionHelper, CrewingHelper, applicationConstants, StyleGenerator, TabService, CommonMasterData) {
                var vm = this;
                var leftPanel = 335;
                vm.min_screen_width = 1200;
                vm.screen_left_panel = leftPanel;
                vm.screen_right_panel = 885;
                vm.minimum_number_of_days = 7;
                vm.openPatternHeight = 70;
                vm.openPatternsTopBuffer = 50;
                vm.headerHeight = 110;
                vm.timeLineData = [];
                vm.openBlockData = [];
                vm.actual_screen_width = screen.width;
                //vm.responsive_right_section_width = screen.width - (vm.screen_left_panel + 70)  - 14;
                vm.responsive_right_section_width = window.innerWidth - (vm.screen_left_panel + 66)  - 14;
                vm.responsive_width = screen.width - 14;
                vm.scrollAreaWidth = 0;
                vm.isOpenParingPanelOpen = false;
                vm.isOpenParingDataAvailable = false;
                vm.cutActionItem = null;
                vm.crewToolTip = {};
                vm.maxDateRangeWidth = null;
                vm.blockToolTiop = {};
                vm.isDragging = false;
                vm.isBlockDragging = false;
                vm.isElasticLoadingVisible = false;
                vm.dragEleOriginalPos = null;
                vm.dragBlockOriginalPos = null;
                vm.isCurrentTimeIndicatorVisible = false;
                vm.pageSize = 30;
                vm.bufferNumberOfRecords = 10;
                vm.rowHeightInPixcel = 50;
                vm.openPairingsMaxTop = 0;
                vm.isBlockViewFlagEnable = false;
                vm.isAlraedyTriggered = true;

                vm.menuActioRelatedContent = {
                    lastAction: null,
                    cut: {
                        cutActionSource: null
                    },
                    copy: {
                        copyActionSource: null
                    },
                    copyMultiple: {
                        copyMultipleActionSource: null
                    },
                    daySelection: {
                        selected: null
                    }
                };

                vm.draggableOpt = {
                    appendTo: "body"
                };

                vm.assignActionTypes = {
                    PAIRING: 'pairing',
                    EVENT: 'event',
                    TRAINING: 'training'
                };

                vm.styleTagTypes = {
                    timeline: 'timeline-style',
                    pattern: 'pattern-style',
                    openPairings: 'open-pairing-style',
                    dataGrid: 'data-grid'
                };

                hotkeys.add({
                    combo: 'del',
                    description: 'delete operation',
                    callback: function(event, hotkey) {
                    	deleteKeyListener();
                    }
                });

                hotkeys.add({
                    combo: 'ctrl+c',
                    description: 'Copy operation',
                    callback: function(event, hotkey) {
                        copyMultipleActionListener();
                    }
                });

                hotkeys.add({
                    combo: 'ctrl+v',
                    description: 'Paste operation',
                    callback: function(event, hotkey) {
                        pasteActionListener();
                    }
                });



                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.SCHEDULE_UPDATED, updateCrewSchedule);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS, onResetSelectedCrewAndDays);

                EventManagerService.registerEventListener(EventManagerService.EVENT.SHOW_HIDE_LOADING, showHideElasticLoading);

                EventManagerService.registerEventListener(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS, onCollapseAllExpandRows);


                /*----------------------------*/
                /*Context Menu Event Listeners*/
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK, deleteBlockListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SWAP, swapAction);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL, deselectAll);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CUT_BLOCK, cutActionListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CANCEL_CUT_OPERATION, cancelCutListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.COPY_DUTY, copyActionListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CANCEL_COPY_OPERATION, cancelCopyActionListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.COPY_MULTIPLE_DUTY, copyMultipleActionListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.PAST_BLOCK, pasteActionListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_CREW_EXPIRY, onShowCrewExpiryListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_OFF, onAssignOffListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SICK_LEAVE, onAssignSickLeaveListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ANNUAL_LEAVE, onAssignAnnualLeaveListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_VOLUNTARILY_UNPAID_LEAVE, onAssignVoluntarilyUnpaidLeaveListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_BLOCK_DAYS, onAssignBlockDaysListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SMS, onSendSmsListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PAIRING, contextMenuAssignPairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT, contextMenuAssignEventListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TRAINING, contextMenuAssignTrainingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ALERT, sendAlertListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_BLOCK, editBlockListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REPLACE_PARING, replacePairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_EVENT, editBlockListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_MEMO, addMemoListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REGULATION_DETAILS, regulationDetailsListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.HISTORY, historyListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_ALL_CREW_SCHEDULE, showAllCrewsInScheduleListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EMAIL_CREW, emailCrewScheduleListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CREW_MOVE_TO_TOP, crewMoveToTopListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CREW_SCHEDULE, crewScheduleListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_PAIRING, editPairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.OPEN_CREW_TRACKING, onOpenCrewTracking);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.PAX_MSG_DETAILS, paxMsgDetailsListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_LEAVE, onAssignUnpaidLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EMERGENCY_LEAVE, onAssignEmergencyLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_IND_LEAVE, onAssignIndLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_HAJJ_LEAVE, onAssignHajjLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMPASSIONATE_LEAVE, onAssignCompassionateLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MATERNITY_LEAVE, onAssignMaternityLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PATERNITY_LEAVE, onAssignPaternityLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SUSPENSION_LEAVE, onAssignSuspensionLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_NOSHOW_LEAVE, onAssignNoShowLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MARRIAGE_LEAVE, onAssignMarriageLeaveListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_SICK_LEAVE, onAssignUnpaidSickLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ABSENT_LEAVE, onAssignAbsentLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMMUTING_LEAVE, onAssignCommutingLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SPECIAL_UNPAID_LEAVE, onAssignSpecialUnpaidLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FM_LEAVE, onAssignFMLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FLEXIBLE_SICK_LEAVE, onAssignFSLVLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SNY_LEAVE, onAssignSNYLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT_OFC, onAssignEventOfcListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_WFD_LEAVE, onAssignWFDLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AWB_LEAVE, onAssignAWBLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_LIM_LEAVE, onAssignLIMLeaveListener);

              /*-----------------------*/
                /*Toolbar Event Listeners*/
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_BLOCK, editBlockListener);

              EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_EVENT, editBlockListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_PAIRING, toolbarAssignPairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_TRAINING, toolbarAssignTrainingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_EVENT, toolbarAssignEventListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.DELETE_BLOCK, deleteBlockListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ADD_MEMO, addMemoListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SMS, onSendSmsListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ALERT, sendAlertListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.REGULATION_DETAILS, regulationDetailsListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.HISTORY, historyListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SHOW_ALL_CREW_SCHEDULE, showAllCrewsInScheduleListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EMAIL_CREW, emailCrewScheduleListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_PAIRING, editPairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.MESSAGEMANAGER, messageManagerListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CNT, onAssignCntListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SECONDEDIN_OTHER_HUBS, onAssignSOHListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SPECIAL_DUTY, onAssignCSDListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SUPPORT_ACTIVITY, onAssignCSAListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AVAILABLE, onAssignAVLListener);

              loadUserPreferencesForRightClickLeaveAssignment();
              loadUserPreferencesForRightClickEventAssignment();

              function loadUserPreferencesForRightClickLeaveAssignment() {
                CommonMasterData.getRightClickLeaveAssignmentOptions(function(preferencesList) {
                  angular.forEach(preferencesList, function (option) {
                    const event = getEventFromCode(option.eventCode);

                    EventManagerService.registerEventListener(event, function (data) {

                      var _param = getContextMenuClickData(data);

                      vm.onDirectAction({
                        param: _param,
                        type: option.eventCode
                      });

                    });

                  });


                }, function () {
                  console.log('Right Click User Leave Preferences Retrieval Eroor!!!');
                });
              }

              function loadUserPreferencesForRightClickEventAssignment() {
                CommonMasterData.getRightClickEventAssignmentOptions(function(preferencesList) {
                  angular.forEach(preferencesList, function (option) {
                    const event = getEventFromCode(option.eventCode);

                    EventManagerService.registerEventListener(event, function (data) {

                      var _param = getContextMenuClickData(data);

                      vm.onDirectAction({
                        param: _param,
                        type: option.eventCode
                      });

                    });

                  });
                }, function () {
                  console.log('Right Click User Event Preferences Retrieval Eroor!!!');
                });
              }

              function getEventFromCode(code){
                return  'event.context_menu.assign_' + code;
              };

                if($(".tabbed-view-container").height() == 0)
                	$(".tabbed-view-container").height(80);

                var height=($("header").height() + $(".tabbed-view-container").height())+"px";
            	$(".canvas").css("top", height);

                $rootScope.$on('draggable:start', function () {
                    vm.isDragging = true;
                });

                $rootScope.$on('draggable:end', function () {
                    vm.isDragging = false;
                });


                if (!!vm.actual_screen_width && vm.actual_screen_width > vm.min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                }
                var currentTimeTimer;
                vm.$onInit = function () {
                    currentTimeTimer = $interval(function () {
                        if (angular.isDefined(vm.minuteToPixelRatio) && vm.maxDateRangeWidth != null) {
                            recalculateCurrentTimeLeftPosition();
                        }
                    }, 30000);

                    vm.pageSize = Math.ceil((screen.height - vm.headerHeight) / vm.rowHeightInPixcel) + vm.bufferNumberOfRecords;
                    $scope.$watch('$ctrl.startIndex', function (newVal, oldVal) {
                        if (
                            (newVal != oldVal) &&
                            (newVal > oldVal) &&
                            (newVal + vm.pageSize > Math.ceil(vm.crewScheduleData.schedule.length / 3))
                        ) {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_ELASTIC_SEARCH);
                        }
                    });

                    setCrewScheduleBlockViewFlagsEnable();
                };

                vm.$onDestroy = function () {
                    if (!!currentTimeTimer) {
                        $interval.cancel(currentTimeTimer);
                    }
                };

                vm.$onChanges = function (changeObj) {
                    if (changeObj.viewMode && changeObj.viewMode.currentValue && (changeObj.viewMode.currentValue != changeObj.viewMode.previousValue)) {
                        vm.minimum_number_of_days = vm.viewMode == 'M' ? 30 : 7;
                        vm.dayWidthInPx = Math.floor(vm.screen_right_panel / vm.minimum_number_of_days);
                        vm.minuteToPixelRatio = vm.dayWidthInPx / (24 * 60);
                        setTimelineData();
                        generateStyleClasses();
                        //setOpenBlockData();
                        setNoofOpenPairings();
                        vm.isAlraedyTriggered = false;
                        recalculateCurrentTimeLeftPosition();
                        //noinspection JSUnresolvedFunction
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }

                    if (changeObj.crewScheduleData && changeObj.crewScheduleData.currentValue && (changeObj.crewScheduleData.currentValue != changeObj.crewScheduleData.previousValue)) {
                        generateStyleClasses();
                        clearMenuActionRelatedContent();
                        recalculateCurrentTimeLeftPosition();
                        CrewingSelectionHelper.crewNamesCol(vm.crewScheduleData.nameCollection);
                        CrewingSelectionHelper.setCrewSchedule(vm.crewScheduleData);
                       	if (angular.isUndefined(vm.blockParams) &&
        				(vm.blockParams == "undefined" && vm.blockParams == "")) {
                        	CrewingSelectionHelper.clearSelections();
                        }
                        vm.startIndex = 0;
                    }

                    if ((changeObj.fromData && changeObj.fromData.currentValue && (changeObj.fromData.currentValue != changeObj.fromData.previousValue)) ||
                        (changeObj.toDate && changeObj.toDate.currentValue && (changeObj.toDate.currentValue != changeObj.toDate.previousValue))) {
                        setTimelineData();
                    }

                    if (changeObj.openPairingData && changeObj.openPairingData.currentValue && (changeObj.openPairingData.currentValue != changeObj.openPairingData.previousValue)) {
                        vm.isOpenParingPanelOpen = changeObj.openPairingData.openBlocks && changeObj.openPairingData.openBlocks.length > 0;
                        vm.isOpenParingDataAvailable = true;
                        vm.isAlraedyTriggered = false;
                        setNoofOpenPairings();
                        //setOpenBlockData();
                    } else {
                        vm.isOpenParingDataAvailable = !!vm.openPairingData;
                    }

                    if (changeObj.currentTime && changeObj.currentTime.currentValue && (changeObj.currentTime.currentValue != changeObj.currentTime.previousValue)) {
                        recalculateCurrentTimeLeftPosition();
                    }
                };

                vm.onCrewNameHover = function (crewId) {
                    var crew;
                    crew = _.findWhere(vm.crewScheduleData.nameCollection, {crewId: crewId});
                    if (!!crew) {
                        vm.crewToolTip = crew;
                        CrewingHelper.getCrewImgUrl(crew.crewProfileId,
                            function (imageUrl) {
                                crew.profileImageUrl = imageUrl;
                            },
                            function (error) {
                                //Show default Image
                            }
                        )
                    }
                };

                vm.onOpenPairingHover = function ( pairing, event) {
                    vm.openPairingTooltip = pairing || {};
                    vm.openPairingTooltip.crewRequirment = pairing.crewRequirment;
//                    vm.openPairingTooltip.placement = findBlockPosition(event);

                };


                vm.onOpenPairingHoverLeave = function ( tooltipIsOpen , event) {
                	tooltipIsOpen = false;
                };

                vm.toggleRightPanelClick = function () {
                    SlideInPanelService.toggle('crewing.right.panel');
                };

                vm.toggleOpenParingPanelClick = function () {
                    if (vm.isOpenParingDataAvailable) {
                    	if(!vm.isOpenParingPanelOpen && !vm.isAlraedyTriggered){
                    		EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    		$timeout(function () {
                    			 setOpenBlockData();
                    			 EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    		 },0);
                    		vm.isAlraedyTriggered = true;
                    	}
                        vm.isOpenParingPanelOpen = !vm.isOpenParingPanelOpen;
                    }
                };

                vm.getContextMenu = function (type, duty) {

                    if (type != 'crew' && type != 'topHeader' && angular.isUndefined(duty)) {
                        return [];
                    }

                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                    var selectedDays = CrewingSelectionHelper.getSelectedDays();
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews();

                    if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
                        var cutSourceCrew = CrewingHelper.getCrewIdFromAdaptedBlock(vm.menuActioRelatedContent.cut.cutActionSource);
                        var cutTargetCrewID = selectedCrews && selectedCrews[0] && selectedCrews[0].crewId;
                        if (cutSourceCrew == cutTargetCrewID) {
                            return ContextMenuService.getContextMenu('CANCEL_CUT_OPERATIONS');
                        } else {
                            return ContextMenuService.getContextMenu('CUT');
                        }
                    }

                    if (!!vm.menuActioRelatedContent.copy.copyActionSource) {
                        var copySourceCrew = CrewingHelper.getCrewIdFromAdaptedBlock(vm.menuActioRelatedContent.copy.copyActionSource);
                        var copyTargetCrewID = selectedCrews && selectedCrews[0] && selectedCrews[0].crewId;
                        if (copySourceCrew == copyTargetCrewID) {
                            return ContextMenuService.getContextMenu('CANCEL_COPY_OPERATIONS');
                        } else {
                            return ContextMenuService.getContextMenu('COPY');
                        }
                    }

                  if (!!vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource) {
                      var selectedBlocks = vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource;
                      var targetCrewID = selectedCrews && selectedCrews[0] && selectedCrews[0].crewId;
                      for (var i = 0; i < selectedBlocks.length; i++) {
                          if (selectedBlocks[i].crewInfo.crewId == targetCrewID) {
                            return ContextMenuService.getContextMenu('CANCEL_COPY_OPERATIONS');
                          }
                      }
                      return ContextMenuService.getContextMenu('COPY');
                  }

                    switch (type) {
                        case 'duty' :
                        {
                            var showOrHide = duty.showInCrewPortal?'VISIBILITY_HIDE':'VISIBILITY_SHOW';
                            var otherMenu = [];
                            var visibilityMenu = [];
                            if(!angular.isUndefined(duty.showInCrewPortal)){
                                visibilityMenu = (vm.isBlockViewFlagEnable) ?   ContextMenuService.getContextMenu(showOrHide) : [];
                            }
                            if(duty.illegalDistIdentifier){
                                otherMenu = ContextMenuService.getContextMenu('SHOW_VIOLATION');
                            }

                            if (selectedBlocks.length > 1) {
                                var multipleCopyMenu = ContextMenuService.getContextMenu('COPY_MULTIPLE');
                                if (isSwappable()) {
                                    return ContextMenuService.getContextMenu('SWAP').concat(visibilityMenu).concat(otherMenu).concat(multipleCopyMenu);
                                } else {
                                    return ContextMenuService.getContextMenu('DELETE').concat(visibilityMenu).concat(otherMenu).concat(multipleCopyMenu);
                                }
                            } else if (!!duty.patternId) {
                                return ContextMenuService.getContextMenu('DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
                            } else {
                                if (CrewingHelper.isLeaveBlock(selectedBlocks[0])) {
                                    return ContextMenuService.getContextMenu('LEAVE').concat(visibilityMenu).concat(otherMenu);
                                } else {
                                  if(!selectedBlocks[0].trainingSlotId){
                                    return ContextMenuService.getContextMenu('DUTY').concat(visibilityMenu).concat(otherMenu);
                                  }
                                  return ContextMenuService.getContextMenu('DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
                                }
                                //     return ContextMenuService.getContextMenu('DUTY').concat(visibilityMenu).concat(otherMenu);
                                // }
                            }
                            break;
                        }
                        case  'date' :
                        {
                            if (selectedDays.length > 1) {
                                return ContextMenuService.getContextMenu('MULTIPLE_DAY_SELECTION');
                            }
                            return ContextMenuService.getContextMenu('DATE');
                            break;
                        }
                        case  'crew':
                        {
                            if (selectedCrews.length > 1) {
                                return ContextMenuService.getContextMenu('MULTIPLE_CREW_SELECTION');
                            } else {
                                return ContextMenuService.getContextMenu('CREW');
                            }
                            break;
                        }
                        case  'pairing' :
                        {

                            var showOrHide = duty.showInCrewPortal?'VISIBILITY_HIDE':'VISIBILITY_SHOW';
                            var visibilityMenu = [],otherMenu=[];
                            if(!angular.isUndefined(duty.showInCrewPortal)){
                                visibilityMenu = (vm.isBlockViewFlagEnable) ?   ContextMenuService.getContextMenu(showOrHide) : [];
                            }
                            if(duty.illegalDistIdentifier){
                                otherMenu = ContextMenuService.getContextMenu('SHOW_VIOLATION');
                            }
                            return ContextMenuService.getContextMenu('PAIRING').concat(visibilityMenu).concat(otherMenu);
                            break;
                        }
                        case 'topHeader':
                        {
                            return ContextMenuService.getContextMenu('TOP_HEADER_DATES');
                            break;
                        }
                    }
                };

                vm.onBlockHover = function (block, event) {
                    vm.blockToolTiop.placement = findBlockPosition(event);
                    vm.blockToolTiop.data = block;
                };

                vm.onPairingDrop = function (e, dragEle, data, crew) {
                    angular.element(e.target).removeClass('over');

                    if (vm.isBlockDragging) {
                        vm.isBlockDragging = false;
                        var block = _.find(data.dropped.events, function (d) {
                            return d.crewScheduleBlockId != null
                        });
                        if (!!block) {
                            var param = {
                                pasteType: 'CUT',
                                isDropped: true,
                                cutCrewProfileId: block.crewInfo.crewProfileId,
                                crewScheduleBlockId: block.crewScheduleBlockId,
                                pasteCrewProfileId: crew.crewDTO.crewProfileId,
                                pasteCrewType: crew.crewDTO.crewTypeCode,
                                crewTypeMasterCode: crew.crewDTO.crewTypeMasterCode,
                                crewIds: [block.crewInfo.crewId, crew.crewId]
                            };
                            vm.onPasteBlock({pasteActionParam: param});
                        }
                    } else {
                        var assignPram = {
                            crewProfileId: crew.crewDTO && crew.crewDTO.crewProfileId,
                            crewTypeMasterCode: crew.crewDTO && crew.crewDTO.crewTypeMasterCode,
                            pattern: data.dropped,
                            isRequest: false,
                            isCallFromDayOff: false
                        };
                        vm.onAssignOpenPairing({params: assignPram});
                    }
                };

                vm.onDropOver = function (e, dragEle, dayObj, crew) {
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.DROP_OVER, {
                        crews: crew,
                        crewNames: _.find(vm.crewScheduleData.nameCollection, {crewId: crew.crewId})
                    });
                    angular.element(e.target).addClass('over');
                };

                vm.onDropOut = function (e) {
                    angular.element(e.target).removeClass('over');
                };

                vm.onBeforeDrop = function (event, dragEle) {
                    var dropElePos = dragEle.position.top;
                    var creScheduleTop = angular.element('.crew-schedule-component').position().top + 60;
                    var openParingPanelTop = angular.element('.open-paring-panel-component').position().top;

                    var deferred = $q.defer();
                    if (dropElePos > creScheduleTop && dropElePos < openParingPanelTop) {
                        deferred.resolve();
                    } else {
                        resetDragElementPosition(vm.dragEleOriginalPos);
                        deferred.reject();
                    }
                    return deferred.promise;
                };

                vm.onBlockDragStop = function () {
                    highlightDropableDays();
                };

                vm.onOpenPairingStop = function () {
                    highlightDropableDays();
                };

                vm.onBeforeBlockDrop = function (e, dragEle, pattern, crew) {
                    var deferred = $q.defer();
                    if (angular.element(e.target).hasClass('crew_' + crew.crewId)) {
                        resetDragElementPosition(dragEle.originalPosition);
                        angular.element(dragEle.draggable).show();
                        deferred.reject();
                    } else {
                        showConfirmPopup();
                    }
                    return deferred.promise;

                    function showConfirmPopup(){
                        var tMsgCol = [];
                        var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                        var fromCrewName = crew.crewDTO.firstName + ' ' + crew.crewDTO.lastName;
                        var toCrewName = selectedCrews &&  selectedCrews[0] &&  ( selectedCrews[0].crewDTO.firstName + ' ' + selectedCrews[0].crewDTO.lastName);
                        tMsgCol.push('Duty will be moved from '+fromCrewName+' to '+toCrewName+'.');
                        tMsgCol.push('Do you wish to Continue ?');

                        var details = {
                            title: 'Confirmation',
                            messages: tMsgCol

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, onClose);
                    }

                    function onClose(param){
                        if(!!param){
                            deferred.resolve();
                        }
                    }
                };

                vm.onBeforeDrag = function (event, dragEle, pattern) {
                    angular.element(dragEle.helper).addClass('move-open-pairing');
                    vm.dragEleOriginalPos = pattern;
                    highlightDropableDays(pattern.patternStartDate);
                };


                vm.onBlockDragStart = function (event, dragEle, pattern) {
                    vm.dragBlockOriginalPos = pattern;
                    highlightDropableDays(pattern.patternStartDate);
                    vm.isBlockDragging = true;
                };


                vm.onReloadOpenParingsClick = function () {
                    vm.onReloadOpenPairingsClick();
                };
                vm.moveOnExpiry = function (e, expiryDetails) {

                    vm.expiryToolTipModel = expiryDetails;
                    vm.expiryToolTipModel.placement = findCheckPosition(e);
                };
                vm.onExpiryClick = function (expiryObj) {
                    var param = {
                        expiryInfo: expiryObj
                    };
                    PopupManager.openModal('SHOW_EXPIRY', param);
                };

                vm.onMemoClick = function (memo) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.OPEN_MEMO, memo);
                };

                vm.onDaySelected = function (crew, day, event) {
                    var context = {
                        days: day,
                        crews: crew,
                        crewNames: _.find(vm.crewScheduleData.nameCollection, {crewId: crew.crewId})
                    };
                    if (event.shiftKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                    } else if (event.ctrlKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.CLICK, context);
                    }
                };

                vm.onDayRightClick = function (clickedScope) {
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        days: clickedScope.day,
                        crews: clickedScope.$parent.crew
                    });
                };

                vm.onBlockRightClick = function (childScope) {
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        crews: childScope.$parent.$parent.crew,
                        patterns: childScope.$parent.pattern,
                        block: childScope.duty
                    });
                };
                vm.onBlockEventClick = function (pattern, crew, duty, event) {
                    var context = {
                        crews: crew,
                        patterns: pattern,
                        block: duty
                    };
                    if (event.ctrlKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else if (event.shiftKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.EVENT_CLICK, context);
                    }
                    event.stopPropagation();
                };
                vm.onPatternRightClick = function (childScope) {
                    if (childScope && childScope.pattern && childScope.pattern.eventType && childScope.pattern.eventType == 'PATTERN') {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                            crews: childScope.$parent.crew,
                            patterns: childScope.pattern,
                            block: childScope.pattern && childScope.pattern.events && childScope.pattern.events[0]
                        });
                    }
                };

                vm.onBlockClick = function (pattern, crew, event) {
                    var context = {
                        crews: crew,
                        patterns: pattern
                    };
                    if (event.ctrlKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else if (event.shiftKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.CLICK, context);
                    }
                };


                vm.onDutyClick = function (childScope) {
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        crews: childScope.$parent.$parent.crew,
                        patterns: childScope.$parent.pattern,
                        block: childScope.duty
                    });
                };

                vm.onCrewNameClick = function (crew) {
                    var context = {
                        crews: crew
                    };
                    if (event.ctrlKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.CREW, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.CREW, CrewingSelectionHelper.INTERACTION.CLICK, context);
                    }
                };

                vm.onCrewNameRightClick = function (clickedScope) {
                    var context = {
                        crews: clickedScope.crew
                    };
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.CREW, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, context);
                };

                vm.cancelEvent = function (event) {
                    event.stopPropagation();
                };

                vm.loadNextSet = function (scrollParam) {
                    if (vm.crewScheduleData.totalRecords > vm.pageSize) {
                        vm.startIndex = scrollParam.nextIndex;
                    }
                };

                vm.onFilterClick = function (clickedDay) {
                    var param = {
                        items: {
                            day: clickedDay
                        }
                    }
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        days: clickedDay
                    });

                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CONTEXT_MENU.SHOW_CREW_FILTER, param);
                };

                vm.onOpenPairingCountClick = function (day) {
                    var encodedDay;
                    if(day && day.date){
                        encodedDay = day.date.replace(/\//g,'-');
                        TabService.gotoTab('tracking', {
                            day: encodedDay,
                            crewType : vm.searchParam.crewType
                        });
                    }
                };

                function setCrewScheduleBlockViewFlagsEnable () {
                    CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                        vm.isBlockViewFlagEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                    });
                }

                function onOpenCrewTracking(clickedDay) {
                    var encodedDay;
                    if(clickedDay && clickedDay.items && clickedDay.items.day && clickedDay.items.day.date){
                        encodedDay = clickedDay.items.day.date.replace(/\//g,'-');
                        TabService.gotoTab('tracking', {
                            day: encodedDay,
                            crewType : vm.searchParam.crewType
                        });
                    }
                }

                function getTimelineStyle() {
                    var timeLine = '';

                    if (!!vm.currentTime && !!vm.crewScheduleData.schedule) {
                        var leftPos = getTimeInMinFromStartDate(vm.currentTime.dateStr, vm.currentTime.timeStr, vm.mo_start);
                        vm.isCurrentTimeIndicatorVisible = leftPos <= vm.maxDateRangeWidth;

                        if (vm.isCurrentTimeIndicatorVisible) {
                            timeLine += ('.time-bar{');
                            timeLine += ('left:' + leftPos + 'px;');
                            timeLine += ('height:' + (parseInt(vm.crewScheduleData.schedule.length * vm.rowHeightInPixcel,10) + 20)+ 'px;');
                            timeLine += '}';
                        }
                    }
                    return timeLine;
                }

                function getPatternStyles() {
                    var styleStr = '';

                    if (vm.crewScheduleData && vm.crewScheduleData.schedule) {
                        angular.forEach(vm.crewScheduleData.schedule, function (crew) {
                            angular.forEach(crew.adaptedRosterDutyDTOs, function (pattern) {
                                var tmpPatternEndInPx;
                                var patternLeftPos = 0;
                                var patternWidth = 0;
                                var iconContainerWidth = 0;
                                pattern.id = _.uniqueId('uid_');
                                if (pattern.eventType == 'PATTERN') {
                                    patternLeftPos = getTimeInMinFromStartDate(pattern.patternStartDate, pattern.patternStartTime, vm.mo_start);
                                    tmpPatternEndInPx = getTimeInMinFromStartDate(pattern.patternEndDate, pattern.patternEndTime, vm.mo_start);

                                    if (tmpPatternEndInPx > vm.maxDateRangeWidth) {
                                        patternWidth = vm.maxDateRangeWidth - patternLeftPos;
                                    } else {
                                        patternWidth = tmpPatternEndInPx - patternLeftPos;
                                    }

                                } else if (pattern.eventType == 'ICON') {
                                    patternLeftPos = getTimeInMinFromStartDate(pattern.eventDate, '00:00', vm.mo_start);
                                    patternWidth = 0;
                                    iconContainerWidth = vm.minuteToPixelRatio * 60 * 23;
                                }

                                styleStr += ('.' + pattern.id + '{left:' + patternLeftPos + 'px;width:' + (patternWidth + 4) + 'px;}');
                                if (!!iconContainerWidth) {
                                    styleStr += ('.' + pattern.id + ' .icon-container{width:' + iconContainerWidth + 'px;}')
                                }

                                var mo_pattern_start = moment(pattern.patternStartDate + ' ' + pattern.patternStartTime, 'DD/MM/YYYY HH:mm');
                                var tmpEventEndInPx;
                                var eventLeftPos = 0;
                                var eventWidth = 0;
                                angular.forEach(pattern.events, function (event) {

                                    event.id = _.uniqueId('uid_');
                                    styleStr += ('#' + event.id + '{');
                                    if (event.type == 'DUTY') {
                                        eventLeftPos = getTimeInMinFromStartDate(event.checkInDate, event.checkInTime, mo_pattern_start);
                                        tmpEventEndInPx = getTimeInMinFromStartDate(event.checkOutDate, event.checkOutTime, mo_pattern_start);
                                        eventWidth = tmpEventEndInPx - eventLeftPos;
                                    } else if (event.type == 'REST') {
                                        eventLeftPos = getTimeInMinFromStartDate(event.restStartDate, event.restStartTime, mo_pattern_start);
                                        tmpEventEndInPx = getTimeInMinFromStartDate(event.restEndDate, event.restEndTime, mo_pattern_start);
                                        eventWidth = tmpEventEndInPx - eventLeftPos;

                                        event.leftPos = eventLeftPos;
                                        event.minimumRest = vm.minuteToPixelRatio * event.minRest;
                                    }
                                    styleStr += 'left:' + eventLeftPos + 'px;background-color:' + event.backColor + ';color:' + event.fontColor + ';';
                                    if (event.borderColor){
                                      styleStr += 'border:2px solid '+ event.borderColor +';'
                                    }

                                    if(event.blueLine){
                                    	event.blueLineLeftPos = eventLeftPos - 7;
                                    }


                                    if (!!eventWidth) {
                                        if (event.type == 'REST') {
                                            styleStr += ('border-right-width:' + eventWidth + 'px;');
                                        } else {
                                            styleStr += ('width:' + eventWidth + 'px;');
                                        }
                                    }
                                    styleStr += '}';
                                });
                            });
                        });
                    }
                    return styleStr;
                }


                /**
                 * Get Style String for Open Pairing elements
                 * @returns {string}
                 */
                function getOpenPairingStyles() {
                    var styleString = '';
                    var blockLeftPos = 0;
                    var blockEndInPx = 0;
                    var blockWidth = 0;
                    var blockTop = 0;
                    if (!!vm.openBlockData) {
                        angular.forEach(vm.openBlockData, function (openBlock) {
                            angular.forEach(openBlock.blocks, function (block) {
                                block.id = _.uniqueId('uid_');
                                blockLeftPos = getTimeInMinFromStartDate(block.patternStartDate, block.patternStartTime, vm.mo_start);
                                blockEndInPx = getTimeInMinFromStartDate(block.patternEndDate, block.patternEndTime, vm.mo_start);
                                blockTop = (block.rowIndex == 0) ? vm.openPatternsTopBuffer : (block.rowIndex * vm.openPatternHeight) + vm.openPatternsTopBuffer;
                                if (blockTop > vm.openPairingsMaxTop) {
                                    vm.openPairingsMaxTop = blockTop;
                                }

                                if (blockEndInPx > vm.maxDateRangeWidth) {
                                    blockWidth = vm.maxDateRangeWidth - blockLeftPos;
                                } else {
                                    blockWidth = blockEndInPx - blockLeftPos;
                                }

                                styleString += ('#' + block.id + '{left:' + blockLeftPos + 'px;width:' + blockWidth + 'px;top:' + blockTop + 'px;}');


                                var mo_pattern_start = moment(block.patternStartDate + ' ' + block.patternStartTime, 'DD/MM/YYYY HH:mm');
                                var eventEndInPx;
                                var eventLeftPos = 0;
                                var eventWidth = 0;
                                angular.forEach(block.events, function (event) {
                                    event.id = _.uniqueId('uid_');
                                    styleString += ('#' + event.id + '{');
                                    if (event.type == 'DUTY') {
                                        eventLeftPos = getTimeInMinFromStartDate(event.checkInDate, event.checkInTime, mo_pattern_start);
                                        eventEndInPx = getTimeInMinFromStartDate(event.checkOutDate, event.checkOutTime, mo_pattern_start);
                                        eventWidth = eventEndInPx - eventLeftPos;
                                    } else if (event.type == 'REST') {
                                        eventLeftPos = getTimeInMinFromStartDate(event.restStartDate, event.restStartTime, mo_pattern_start);
                                        eventEndInPx = getTimeInMinFromStartDate(event.restEndDate, event.restEndTime, mo_pattern_start);
                                        eventWidth = eventEndInPx - eventLeftPos;
                                    }
                                    styleString += ('left:' + eventLeftPos + 'px;background-color:#74838e;color:' + event.fontColor + ';');

                                    if (!!eventWidth) {
                                        if (event.type == 'REST') {
                                            styleString += ('border-right-width:' + eventWidth + 'px;');
                                        } else {
                                            styleString += ('width:' + eventWidth + 'px;');
                                        }
                                    }
                                    styleString += '}';
                                });
                            });
                        });
                    }
                    return styleString;
                };


                /**
                 * Get Style String for date Grid items
                 * @returns {string}
                 */
                function getDataGridStyles() {
                    var styleString = '';
                    if (!!vm.dayWidthInPx) {
                        styleString += ('.day{width:' + vm.dayWidthInPx + 'px;}');
                    }
                    //set open Pairing Day Height
                    if (!!vm.openPairingsContainerHeight) {
                        styleString += ('.open-pairing-day{height:' + vm.openPairingsContainerHeight + 'px !important;}');
                    }
                    return styleString;
                }


                /**
                 * Generate Style Classes and append to head for grid eliments
                 * @param type
                 */
                function setCrewingStyles(type) {
                    var styleString = '';
                    switch (type) {
                        case vm.styleTagTypes.timeline :
                        {
                            styleString = getTimelineStyle();
                            break;
                        }
                        case vm.styleTagTypes.pattern :
                        {
                            styleString = getPatternStyles();
                            break;
                        }
                        case vm.styleTagTypes.openPairings :
                        {
                            styleString = getOpenPairingStyles();
                            break;
                        }
                        case vm.styleTagTypes.dataGrid :
                        {
                            styleString = getDataGridStyles();
                            break;
                        }
                    }

                    if (!!styleString) {
                        StyleGenerator.addStyleTag(type,styleString);
                    }
                }


                function findCheckPosition(e) {
                    var H = 'left', V = 'top';
                    if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                        H = 'left';
                    } else {
                        H = 'right';
                    }
                    if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                        V = 'bottom';
                    } else {
                        V = 'top';
                    }
                    return H + '-' + V;
                }

                function findBlockPosition(e) {
                    var bottomOffset = 150;
                    var popupSize = 250;
                    var H = 'left', V = 'top';
                    if ((e.clientX + e.target.offsetWidth + popupSize) > $window.innerWidth) {
                        H = 'left';
                    } else {
                        H = 'right';
                    }

                    if ((e.clientY  ) > ($window.innerHeight - bottomOffset)) {
                        V = 'bottom';
                    } else {
                        V = 'top';
                    }
                    return H + '-' + V;
                }

                function messageManagerListener() {
                	var params = getSelectedFirstDayAndFirstCrew();
                	PopupManager.openModal('MESSAGE_MANAGER', params);
                }

                function editPairingListener() {
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();

                    if (!!selectedCrews.length && !!selectedBlocks.length) {
                        if (selectedBlocks.length > 1) {
                            MessageService.warning(MessageService.MESSAGES.CREWING.OPERATION_NOT_SUPPORTED_FOR_MULTIPLE_BLOCKS);
                        } else {
                            var block = selectedBlocks[0];
                            if (!!block.patternId) {
                                var tmpParam = {
                                    crew: selectedCrews[0],
                                    block: selectedBlocks[0]
                                };
                                vm.onEditPairing({params: tmpParam});
                            } else {
                                MessageService.warning(MessageService.MESSAGES.CREWING.BLOCK_NOT_PART_OF_A_PATTERN);
                            }
                        }
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function recalculateCurrentTimeLeftPosition() {
                    try {
                        setCrewingStyles(vm.styleTagTypes.timeline);
                    } catch (e) {
                        vm.isCurrentTimeIndicatorVisible = false;
                        console.log('current timeline calculation exception');
                    }
                }

                function getContextMenuClickData() {
                  var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                  var selectedDays = CrewingSelectionHelper.getSelectedDays();
                  var tmp = {
                    crewProfileId: selectedCrews[0].crewDTO.crewProfileId,
                    crewId: selectedCrews[0].crewId,
                    crewName: selectedCrews[0].crewDTO.firstName + ' ' + selectedCrews[0].crewDTO.lastName,
                    isOnProbation: selectedCrews[0].crewDTO.isOnProbation,
                    dateClicked: selectedDays[0].date,
                    isMultiple: false,
                    forceAssignLeave: false
                  };

                  if (selectedDays.length == 1) {
                    tmp.startDate = selectedDays[0].date;
                    tmp.endDate = selectedDays[0].date;;
                  } else if (selectedDays.length > 1) {
                    var sorted = _.sortBy(selectedDays, function (obj) {
                      return obj.dayIndex;
                    });
                    tmp.startDate = sorted[0].date;
                    tmp.endDate = sorted[sorted.length - 1].date;
                    tmp.isMultiple = true;

                    var isFirst = true;
                    var previous = null;
                    var customSelectedDates = false
                    for (var i = 0; i < sorted.length; i++) {

                      if (isFirst) {
                        isFirst = !isFirst;
                        previous = sorted[i];
                        continue;
                      }

                      var current = sorted[i];
                      const date1 = moment(previous.date, "DD/MM/YYYY");
                      const date2 = moment(current.date, "DD/MM/YYYY");
                      const diffTime = Math.abs(date2 - date1);
                      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                      if (diffDays >= 1) {
                        customSelectedDates = true;
                        break;
                      }
                    };

                    if (customSelectedDates) {
                      tmp.isCustomSelectedDates = true;
                      tmp.customSelectedDates = [];

                      var sorted = _.sortBy(selectedDays, function (obj) {
                        return obj.dayIndex;
                      });

                      angular.forEach(sorted, function (value, key) {
                        tmp.customSelectedDates.push(value.date);
                      });
                    }
                  }

                  return tmp;
                }

              function getContextMenuClickDataForOfc() {
                var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                var selectedDays = CrewingSelectionHelper.getSelectedDays();
                var tmp = {
                  crewProfileId: selectedCrews[0].crewDTO.crewProfileId,
                  crewId: selectedCrews[0].crewId,
                  crewName: selectedCrews[0].crewDTO.firstName + ' ' + selectedCrews[0].crewDTO.lastName,
                  isOnProbation: selectedCrews[0].crewDTO.isOnProbation,
                  dateClicked: selectedDays[0].date,
                  isMultiple: false,
                  forceAssignLeave: false
                };

                if (selectedDays.length == 1) {
                  tmp.startDate = selectedDays[0].date;
                  tmp.endDate = selectedDays[0].date;;
                } else if (selectedDays.length > 1) {
                  var sorted = _.sortBy(selectedDays, function (obj) {
                    return obj.dayIndex;
                  });
                  tmp.startDate = sorted[0].date;
                  tmp.endDate = sorted[sorted.length - 1].date;
                  tmp.isMultiple = true;

                  var isFirst = true;
                  var previous = null;
                  var customSelectedDates = false
                  for (var i = 0; i < sorted.length; i++) {

                    if (isFirst) {
                      isFirst = !isFirst;
                      previous = sorted[i];
                      continue;
                    }

                    var current = sorted[i];
                    const date1 = moment(previous.date, "DD/MM/YYYY");
                    const date2 = moment(current.date, "DD/MM/YYYY");
                    const diffTime = Math.abs(date2 - date1);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                    if (diffDays > 1) {
                      customSelectedDates = true;
                      break;
                    }
                  };

                  if (customSelectedDates) {
                    tmp.isCustomSelectedDates = true;
                    tmp.customSelectedDates = [];

                    var sorted = _.sortBy(selectedDays, function (obj) {
                      return obj.dayIndex;
                    });

                    angular.forEach(sorted, function (value, key) {
                      tmp.customSelectedDates.push(value.date);
                    });
                  }
                }

                return tmp;
              }

                function onAssignCntListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.cnt})
                }

              function onAssignSOHListener(data) {
                var _param = getContextMenuClickData(data);
                _param["selectedBase"] = data.selectedBase;
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.secondedinOtherHubs})
              }

              function onAssignCSDListener(data) {
                var _param = getContextMenuClickData(data);
                _param["selectedBase"] = data.selectedBase;
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.cabinSpecialDuty})
              }

              function onAssignCSAListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.cabinSupportActivity})
              }

              function onAssignAVLListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.available})
              }

              //--------------------------------------------------------------------------------------//
              function onAssignUnpaidLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.ulvLeave})
              }

              function onAssignEmergencyLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.elvLeave})
              }
              function onAssignIndLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.indLeave})
              }
              function onAssignHajjLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.hajLeave})
              }

              function onAssignCompassionateLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.comLeave})
              }
              function onAssignMaternityLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.matLeave})
              }
              function onAssignPaternityLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.patLeave})
              }
              function onAssignUnpaidSickLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.uslLeave})
              }
              function onAssignMarriageLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.marLeave})
              }
              function onAssignSuspensionLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.susLeave})
              }
              function onAssignNoShowLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.nshLeave})
              }
              function onAssignAbsentLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.absLeave})
              }
              function onAssignCommutingLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.clvLeave})
              }
              function onAssignSpecialUnpaidLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.sulvLeave})
              }
              function onAssignFMLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.fmLeave})
              }
              function onAssignFSLVLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.fslvLeave})
              }
              function onAssignSNYLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.snyLeave})
              }
              function onAssignAWBLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.awbLeave })
              }


              function onAssignLIMLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.limLeave })
              }

              function onAssignWFDLeaveListener(data) {
                var _param = getContextMenuClickData(data);
                vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.wfdLeave })
              }

              //------------------------------------------------------------------------------------------//

                function onAssignOffListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.off})
                }

                function onAssignSickLeaveListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.sickLeave})
                }

                function onAssignAnnualLeaveListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.annualLeave})
                }

                function onAssignVoluntarilyUnpaidLeaveListener(data) {
                  var _param = getContextMenuClickData(data);
                  vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.vulvLeave})
                }

                function onAssignBlockDaysListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.blockDays})
                }

                function onSendSmsListener() {
                	var selectedDays = CrewingSelectionHelper.getSelectedDays();
                	var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                	if(selectedDays.length != 0){
                		var params = getSelectedFirstDayAndFirstCrew();
                		params.isForDay = true;
                		if (params !== null) {
                			vm.onSendSms.call(this, {param: params});
                		}
                	} else if(selectedBlocks.length != 0) {
                		var params = selectedBlocks[0].events[0];
                		if(params.eventCategory === "LEAVE") {
                            MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                            return;
                		}
                		params.isForBlock = true;
            			CrewingHelper.getJoiningCrewList(params.crewScheduleBlockId,!!params.patternId,
            					function(crews) {
            				params.joiningCrew = crews.joiningCrewDTOS;
            				vm.onSendSms.call(this, {param: params});
            			},
            			function(error) {
            				MessageService.error(error);
            			});
                	} else {
                		MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                	}
                }

                function contextMenuAssignPairingListener() {
                    assignAction(vm.assignActionTypes.PAIRING);
                }

                function toolbarAssignPairingListener() {
                    assignAction(vm.assignActionTypes.PAIRING);
                }

                function contextMenuAssignEventListener() {
                    assignAction(vm.assignActionTypes.EVENT);
                }

                function toolbarAssignEventListener() {
                    assignAction(vm.assignActionTypes.EVENT);
                }

                function contextMenuAssignTrainingListener() {
                    assignAction(vm.assignActionTypes.TRAINING);
                }

                function toolbarAssignTrainingListener() {
                    assignAction(vm.assignActionTypes.TRAINING);
                }

                function assignAction(type) {
                    var _params = getSelectedDayAndCrew();
                    if (_params !== null) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.ROW, CrewingSelectionHelper.INTERACTION.EXPAND, {
                            crews: _params.crew[0]
                        });

                        _params.container = '#crewName_' + _params.crew[0].crewId;
                        vm.isExpandName = true;

                        switch (type) {
                            case vm.assignActionTypes.PAIRING :
                            {
                                vm.onAssignPairing({params: _params});
                                break;
                            }
                            case vm.assignActionTypes.TRAINING :
                            {
                                vm.onAssignTraining({params: _params});
                                break;
                            }
                            case vm.assignActionTypes.EVENT :
                            {
                                vm.onAssignEvent({params: _params});
                                break;
                            }
                        }
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function editBlockListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();

                    if (!!crewSelection && !!selectedDuty) {
                        var _param = {
                            duty: selectedDuty,
                            crew: crewSelection[0],
                            container: '#crewName_' + crewSelection[0].crewId
                        };

                        if(!!_param.duty.eventId && ! _param.duty.updatableEvent){
                          MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                        }

                      if (!!_param.duty.eventId && ((!!_param.duty.blockDetailCount && _param.duty.blockDetailCount===1) || (_param.duty.patternId === null || _param.duty.patternId === 0))){
                        //if (!!_param.duty.eventId && _param.duty.blockDetailCount ===1) {
                            if (_param.duty.updatableEvent) {
                                CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.ROW, CrewingSelectionHelper.INTERACTION.EXPAND, {
                                    crews: _param.crew
                                });
                                vm.isExpandName = true;
                                vm.onEditBlock.call(this, {params: _param});
                            } else {
                                MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                            }
                        } else {
                            vm.onEditBlock.call(this, {params: _param});
                        }
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

              function replacePairingListener() {
                var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                var selectedDuty = CrewingSelectionHelper.getSelectedDuty();

                if (!!crewSelection && !!selectedDuty) {
                  var _param = {
                    duty: selectedDuty,
                    crew: crewSelection[0],
                    crews: _params.crew[0],
                    day: daySelection,
                    container: '#crewName_' + crewSelection[0].crewId
                  };

                  if(!!_param.duty.eventId && ! _param.duty.updatableEvent){
                    MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                  }

                  if (!!_param.duty.eventId && ((!!_param.duty.blockDetailCount && _param.duty.blockDetailCount===1) || (_param.duty.patternId === null))){
                    //if (!!_param.duty.eventId && _param.duty.blockDetailCount ===1) {
                    if (_param.duty.updatableEvent) {
                      CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.ROW, CrewingSelectionHelper.INTERACTION.EXPAND, {
                        crews: _param.crew
                      });
                      vm.isExpandName = true;
                      vm.onReplacePairing.call(this, {params: _param});
                    } else {
                      MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                    }
                  } else {
                    vm.onReplacePairing.call(this, {params: _param});
                  }
                } else {
                  MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                }
              }

                function addMemoListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onAddMemo.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function regulationDetailsListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();

                    if (!!selectedDuty) {

                        if (selectedDuty.eventCategory == 'LEAVE') {
                            MessageService.warning(MessageService.MESSAGES.CREWING.NO_REGULATIONS_FOR_LEAVES);
                        } else {
                            var _param = {
                                crew: crewSelection[0],
                                block: selectedDuty
                            };
                            vm.onShowRegulations.call(this, {params: _param});
                        }
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function paxMsgDetailsListener() {
                	var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


                    if (!!selectedDuty) {
                        var _param = {
                            crew: crewSelection[0],
                            block: selectedDuty
                        };
                        vm.onShowPaxMsgDet.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }

				}
              function onAssignEventOfcListener(data) {
                var _param = getContextMenuClickDataForOfc(data);
                vm.onAssignDirectOfcEventInRosters.call(this,{ params: _param })
              }
                function historyListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onShowHistory.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function showAllCrewsInScheduleListener() {
                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                    if (selectedBlocks.length > 0) {
                        var _param = {
                            block: selectedBlocks[0]
                        };
                        vm.onShowAllCrewsInSchedule.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function emailCrewScheduleListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    if (crewSelection.length > 0) {
                        var details = {
                            title: 'Confirmation',
                            messages: ['Do you want to send Crew Schedule as an Email?']

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, emailSchedule);

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function emailSchedule(param) {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    if (!!param) {
                        var _param = {
                            crews: crewSelection
                        };
                        vm.onEmailCrewSchedule.call(this, {params: _param});
                    }
                }

                function crewMoveToTopListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    if (crewSelection.length > 0) {
                        var creIds = _.pluck(crewSelection, 'crewId');
                        CrewingHelper.moveCrewToTop(creIds);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL_TO_TOP, 'crewSchedulePanel');
                    }
                }

                function crewScheduleListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    if (crewSelection.length > 0) {
                        vm.onShowCrewSchedule({params: crewSelection});
                    }
                }

                function sendAlertListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onSendAlert({param: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }


                function getSelectedDayAndCrew() {
                    var daySelection = CrewingSelectionHelper.getSelectedDays();
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();

                    if (daySelection && daySelection.length > 0 && crewSelection && crewSelection.length > 0) {
                        var _params = {
                            day: daySelection,
                            crew: crewSelection
                        };
                        return _params;
                    }
                    return null;
                }


                function getSelectedFirstDayAndFirstCrew() {
                    var daySelection = CrewingSelectionHelper.getSelectedDays();
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();

                    if (daySelection && daySelection.length > 0 && crewSelection && crewSelection.length > 0) {
                        var _params = {
                            day: daySelection[0],
                            crew: crewSelection[0]
                        };
                        return _params;
                    }
                    return null;
                }


                function highlightDropableDays(dateStr) {
                    angular.forEach(vm.timeLineData, function (day) {
                        day.isDropableContainer = (day.date == dateStr);
                    });
                }

                function onResetSelectedCrewAndDays() {
                    CrewingSelectionHelper.clearSelections();
                }

                function onShowCrewExpiryListener(childScope) {
                	var crewId = childScope.items.crew.crewId;
                	var searchEndDate = childScope.modelValue.startDay;
                	loadExpiries({crewId:crewId,endDate:searchEndDate});
                }

                function loadExpiries(data){
                	var param = populateExpierySearchRequest(data);
                	CrewingHelper.getCrewExpiries(param,setExpiriesInfo,showErrorInfo );
                };

                function populateExpierySearchRequest(data){
                	var request = new SearchCriteriaDTO();
                	request.fromDate = data.endDate;
                	request.crewId = data.crewId;
                	return request;
                };

                function setExpiriesInfo(response){
                	var param = {
                        expiryInfo: {EXPIRY:response.crewExpiryDTOs}
                    };
                    PopupManager.openModal('SHOW_EXPIRY', param);
                };

                function showErrorInfo(error){
//              	  MessageService.warning(MessageService.MESSAGES.CREWING.CREW_SCHEDULE_NOT_LOADED);
                };

                function resetDragElementPosition(dragEleOriginalPos) {
                    var left = dragEleOriginalPos.leftPos;
                    var top = dragEleOriginalPos.topPos;
                    dragEleOriginalPos.leftPos = left + 1;
                    dragEleOriginalPos.topPos = top + 1;  //This is a hack to tell ng-repeat that data has being change and rerender element

                    $timeout(function () {
                        dragEleOriginalPos.leftPos = left;
                        dragEleOriginalPos.topPos = top;
                    }, 0);
                }


                function showHideElasticLoading(data) {
                    if (data.target == 'crewing') {
                        vm.isElasticLoadingVisible = data.flag;

                        if(data.flag && angular.element('.elasticLoadingOverlay').length == 0) {
                        	var overlay = angular.element('<div class="elasticLoadingOverlay"></div>');

                        	overlay.css({
                        	    'background-color': '#eee',
                        	    'opacity': '0.8',
                        	    'position': 'absolute',
                        	    'left': '0px',
                        	    'top': '0px',
                        	    'z-index': '1100',
                        	    'height': '100%',
                        	    'width': '100%',
                        	    'overflow': 'hidden',
                        	    'background-image': "url('ajax-loader.gif')",
                        	    'background-position': 'center',
                        	    'background-repeat': 'no-repeat',
                        	    });
                        	angular.element(document.body).append(overlay);
                        	//angular.element('#elasticLoadingBanner').removeClass('ng-hide');
                        	angular.element('.right-section').css('overflow', 'hidden');
                    	} else if (data.flag) {
                    	    angular.element('.elasticLoadingOverlay').removeClass('ng-hide');
                    	    //angular.element('#elasticLoadingBanner').removeClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'hidden');
                    	} else {
                    	    angular.element('.elasticLoadingOverlay').addClass('ng-hide');
                    	    //angular.element('#elasticLoadingBanner').addClass('ng-hide');
                    	    angular.element('.right-section').css('overflow', 'auto');
                    	}
                    }
                }

                function onCollapseAllExpandRows() {
                    CrewingSelectionHelper.clearRowExpands();
                    vm.isExpandName = false;
                }

                function clearMenuActionRelatedContent() {
                    vm.menuActioRelatedContent.cut.cutActionSource = null;
                    vm.menuActioRelatedContent.copy.copyActionSource = null;
                    vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource = null;
                }

                function cancelCopyActionListener() {
                    vm.menuActioRelatedContent.lastAction = null;
                    clearMenuActionRelatedContent();
                    CrewingSelectionHelper.clearSelections();
                }

                function copyActionListener() {
                    var selected = CrewingSelectionHelper.getSelectedBlocks();
                    vm.menuActioRelatedContent.lastAction = 'COPY';
                    vm.menuActioRelatedContent.copy.copyActionSource = selected[0];

                    if(selected.length > 1) {
                      copyMultipleActionListener()
                    }
                }

                function copyMultipleActionListener() {
                  var selected = CrewingSelectionHelper.getSelectedCrewScheduleBlocks();
                  if(selected.length > 0) {
                    vm.menuActioRelatedContent.lastAction = 'COPY_MULTIPLE';
                    vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource = selected;
                  }
                }

                function cutActionListener() {
                    var selected = CrewingSelectionHelper.getSelectedBlocks();
                    vm.menuActioRelatedContent.lastAction = 'CUT';

                    if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
                        vm.menuActioRelatedContent.cut.cutActionSource.isCutPerformed = false;
                    }

                    vm.menuActioRelatedContent.cut.cutActionSource = selected[0];
                    vm.menuActioRelatedContent.cut.cutActionSource.isCutPerformed = true;
                }

                function pasteActionListener() {
                    var lastAction = vm.menuActioRelatedContent.lastAction;
                    vm.menuActioRelatedContent.lastAction = null;
                    if (lastAction == 'CUT') {
                        performPasteForCutOperation();
                    } else if (lastAction == 'COPY') {
                        performPasteForCopyOperation();
                    } else if (lastAction == 'COPY_MULTIPLE'){
                        performPasteForMultipleCopyOperation()
                    }
                }

                function performPasteForCutOperation() {
                    if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
                        var t = angular.copy(vm.menuActioRelatedContent.cut.cutActionSource),
                            block = _.find(t.events, function (d) {
                                return d.crewScheduleBlockId != null
                            }),
                            selectedCrews = CrewingSelectionHelper.getSelectedCrews(),
                            crew = selectedCrews[0],
                            param = {
                                pasteType: 'CUT',
                                cutCrewProfileId: block.crewInfo.crewProfileId,
                                crewScheduleBlockId: block.crewScheduleBlockId,
                                patternId: block.patternId,
                                patternType: block.patternType,
                                pasteCrewProfileId: crew.crewDTO.crewProfileId,
                                pasteCrewType: crew.crewDTO.crewTypeCode,
                                crewTypeMasterCode: crew.crewDTO.crewTypeMasterCode,
                                crewIds: [block.crewInfo.crewId, crew.crewId]
                            };
                        vm.menuActioRelatedContent.cut.cutActionSource.isCutPerformed = false;
                        vm.menuActioRelatedContent.cut.cutActionSource = null;

                        vm.onPasteBlock({pasteActionParam: param});
                    }
                }

                function performPasteForCopyOperation() {
                    if (!!vm.menuActioRelatedContent.copy.copyActionSource) {
                        var selectedCrews = CrewingSelectionHelper.getSelectedCrews(),
                            t = angular.copy(vm.menuActioRelatedContent.copy.copyActionSource),
                            block = _.find(t.events, function (d) {
                                return d.crewScheduleBlockId != null
                            }),

                            crew = selectedCrews[0],
                            param = {
                                pasteType: 'COPY',
                                crewProfileId: crew.crewDTO.crewProfileId,
                                crewScheduleBlockId: block.crewScheduleBlockId,
                                patternId: block.patternId,
                                patternType: block.patternType,
                                crewType: crew.crewDTO.crewTypeCode,
                                crewTypeMasterCode: crew.crewDTO.crewTypeMasterCode,
                                crewIds: [crew.crewId]
                            };
                        vm.menuActioRelatedContent.copy.copyActionSource = null;
                        vm.onPasteBlock({pasteActionParam: param});
                    }
                }

                function performPasteForMultipleCopyOperation(){
                  if (!!vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource) {
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews(),
                      csBlocks = angular.copy(vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource),

                      crew = selectedCrews[0],
                      param = {
                        pasteType: 'COPY_MULTIPLE',
                        crewDTO: crew.crewDTO,
                        crewScheduleBlocks: csBlocks,
                        crewIds: [crew.crewId]
                      };
                    vm.menuActioRelatedContent.copyMultiple.copyMultipleActionSource = null;
                    vm.onPasteBlock({pasteActionParam: param});
                  }
                }

                function cancelCutListener() {
                    if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
                        vm.menuActioRelatedContent.cut.cutActionSource.isCutPerformed = false;
                        vm.menuActioRelatedContent.cut.cutActionSource = null;
                    }
                }


                function deselectAll() {
                    CrewingSelectionHelper.clearSelections();
                }

                function swapAction() {
                    vm.menuActioRelatedContent.lastAction = 'SWAP';
                    var blocks = CrewingSelectionHelper.getSelectedBlocks(),
                        blockOne = angular.copy(blocks[0]),
                        blockTwo = angular.copy(blocks[1]),
                        dOne = _.find(blockOne.events, {type: 'DUTY'}),
                        dTwo = _.find(blockTwo.events, {type: 'DUTY'});

                    vm.onSwapDuty({firstDuty: dOne, secondDuty: dTwo});
                    CrewingSelectionHelper.clearSelections();
                }

                function updateCrewSchedule() {
                    setCrewingStyles(vm.styleTagTypes.pattern);
                    setCrewingStyles(vm.styleTagTypes.timeline);
                }

                function deleteBlock(param) {
                    if (!!param) {
                        var blocks = CrewingSelectionHelper.getSelectedBlocks();
                        var toBeDeleted = CrewingHelper.getDutyAndCrewCollectionFromSelectedBlocks(blocks);
                        vm.onBlockDelete({blocks: toBeDeleted});
                    }
                }

                function deleteBlockListener() {
                    var blocks = CrewingSelectionHelper.getSelectedBlocks();
                    if (blocks.length > 0) {
                        var details = {
                            title: 'Confirmation',
                            messages: ['Selected record will be Deleted. Do you wish to Continue?']

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, deleteBlock);

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function isSwappable() {
                    var blocks = CrewingSelectionHelper.getSelectedBlocks();
                    var crews = CrewingSelectionHelper.getSelectedCrews();

                    if (blocks.length == 2 && crews.length == 2) {
                        return true;
                    }
                    return false;
                }

                function getTimeInMinFromStartDate(checkInDate, checkInTime, relativeTo) {
                    var mo_checkIn = moment(checkInDate + ' ' + checkInTime, 'DD/MM/YYYY HH:mm');
                    var diffFromStart = mo_checkIn.diff(relativeTo, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function generateStyleClasses() {
                    setCrewingStyles(vm.styleTagTypes.dataGrid);
                    setCrewingStyles(vm.styleTagTypes.pattern);
                    setCrewingStyles(vm.styleTagTypes.timeline);
                }

                /**
                 * Generate Timeline data for the Search Period
                 */
                function setTimelineData() {
                    /*Prepare Timeline Data*/
                    var tmp,
                        dateLbl,
                        weekStart = applicationConstants.SETTINGS.WEEK_START_DAY,
                        _isWeekStart = function (dayString, weekStart) {
                            return $filter('uppercase')(dayString) == $filter('uppercase')(weekStart);
                        };
                    vm.dateDiff = getNoOfDays();
                    vm.timeLineData.length = 0;
                    vm.scrollAreaWidth = 0;
                    vm.maxDateRangeWidth = (vm.dateDiff + 1) * vm.dayWidthInPx;


                    for (var i = 0; i <= vm.dateDiff; i++) {
                        tmp = moment(vm.mo_start).add(i, 'd');
                        dateLbl = tmp.format('DD/MM/YYYY')
                        vm.timeLineData.push({
                            dayOfWeek: tmp.format('ddd'),
                            dayOfWeekShort: tmp.format('dd'),
                            date: dateLbl,
                            dateShort: tmp.format('DD/MM'),
                            dayIndex: i,
                            isWeekStart: _isWeekStart(tmp.format('dddd'), weekStart)
                        });
                        vm.scrollAreaWidth += vm.dayWidthInPx;
                    }
                    CrewingSelectionHelper.setTimeLineDaysCol(vm.timeLineData);
                    if (!angular.isUndefined(vm.blockParams) &&
        				(vm.blockParams != "undefined" && vm.blockParams != "")) {
                    	var blockParam = vm.blockParams;
                    	CrewingSelectionHelper.addBlockAndSelectTimeInHeader(blockParam);
                    }
                }

                function getNoOfDays() {
                    vm.mo_start = moment(vm.fromData, vm.dateFormat);
                    vm.mo_end = moment(vm.toDate, vm.dateFormat);
                    var dateDiff = vm.mo_end.diff(vm.mo_start, 'days');

                    if (dateDiff < vm.minimum_number_of_days) {
                        dateDiff = vm.minimum_number_of_days - 1;
                    }
                    return dateDiff;
                };

                function setNoofOpenPairings() {
                	var dateDiff = getNoOfDays();
                    var tmp, dateLbl;
                    vm.openBlockData.length = 0;
                    for (var i = 0; i <= dateDiff; i++) {
                        tmp = moment(vm.mo_start).add(i, 'd');
                        dateLbl = tmp.format('DD/MM/YYYY');

                        if(!!vm.timeLineData){
                            var found = _.find(vm.timeLineData,{date : dateLbl});
                            if(!!found && vm.openPairingData){
                                found.openPairingCount = (vm.openPairingData.openBlocks[dateLbl] && vm.openPairingData.openBlocks[dateLbl].length) || 0
                            }
                        }
                    }

                   /* setCrewingStyles(vm.styleTagTypes.openPairings);
                    setCrewingStyles(vm.styleTagTypes.dataGrid);
					vm.openPairingsContainerHeight = vm.openPatternsTopBuffer + vm.openPairingsMaxTop + vm.openPatternHeight;*/


                }

                function setOpenBlockData() {
                    var dateDiff = getNoOfDays();
                    var tmp, dateLbl;
                    vm.openBlockData.length = 0;
                    for (var i = 0; i <= dateDiff; i++) {
                        tmp = moment(vm.mo_start).add(i, 'd');
                        dateLbl = tmp.format('DD/MM/YYYY');
                        vm.openBlockData.push({
                            dayId: i,
                            date: tmp.format('DD/MM/YYYY'),
                            blocks: (vm.openPairingData && vm.openPairingData.openBlocks && vm.openPairingData.openBlocks[dateLbl]) || []
                        });

                        if(!!vm.timeLineData){
                            var found = _.find(vm.timeLineData,{date : dateLbl});
                            if(!!found && vm.openPairingData){
                                found.openPairingCount = (vm.openPairingData.openBlocks[dateLbl] && vm.openPairingData.openBlocks[dateLbl].length) || 0
                            }
                        }
                    }

                    setCrewingStyles(vm.styleTagTypes.openPairings);
                    setCrewingStyles(vm.styleTagTypes.dataGrid);

                    vm.openPairingsContainerHeight = vm.openPatternsTopBuffer + vm.openPairingsMaxTop + vm.openPatternHeight;
                    setCrewingStyles(vm.styleTagTypes.dataGrid);
                }

                angular.element($window).bind('resize',function(){
                	vm.responsive_right_section_width = window.innerWidth - (vm.screen_left_panel + 66)  - 14;
                	/*if(screen.width < window.innerWidth)
                		angular.element('.canvas').css('width', '98%');*/
                });


                function deleteKeyListener(){
                	var blocks = CrewingSelectionHelper.getSelectedBlocks();
                	if(blocks.length == 0){
                		MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                	}
                	else if(blocks.length == 1){
                		if(blocks[0].eventType == "PATTERN"){
                			deleteBlockListener();
                		}
                	}
                	else{
                		deleteBlockListener();
                	}
                }

                function SearchCriteriaDTO() {
                    this.fromDate = null;
                    this.crewId = null;
                };

              vm.onDoubleClickBlock = function(){
                editBlockListener();
              };
            }
        });
})();

